// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatEvent_wrapper__gKvO6","scrollToSpan":"ChatEvent_scrollToSpan__1u2B0"};